@let enhancement = writingHelperFeature.selectors.enhancement.asSignal();
@let enhancementTypeOptions =
  writingHelperFeature.selectors.enhancementTypeOptions.asSignal();
@let isCreatingCustomEnhancementType =
  writingHelperFeature.selectors.isCreatingCustomEnhancementType.asSignal();

<ng-template
  #header
  let-title="title"
>
  <div class="atn-platform-writing-helper-pop-up__header">
    <h6 class="atn-platform-writing-helper-pop-up__label">{{ title }}</h6>
    <i
      class="atn-platform-writing-helper-pop-up__close-icon atn-icon atn-close atn-red"
      (click)="
        writingHelperFeature.actions.quit
          .from('WritingHelper.PopUp.CloseIcon.Clicked')
          .dispatch()
      "
    ></i>
  </div>
</ng-template>

@if (enhancement) {
  <ng-container
    *ngTemplateOutlet="header; context: { title: 'What do you think of this?' }"
  ></ng-container>
  <div class="atn-platform-writing-helper-pop-up__editor">
    <atn-ds-text-area
      class="atn-platform-writing-helper-pop-up__editor-input"
      [value]="enhancement"
    />
    <i
      class="atn-icon atn-approve atn-blue"
      (click)="
        writingHelperFeature.actions.applyEnhancement
          .from('WritingHelper.PopUp.ApplyEnhancement.Clicked')
          .dispatch()
      "
    ></i>
  </div>
} @else if (isCreatingCustomEnhancementType) {
  <ng-container
    *ngTemplateOutlet="
      header;
      context: { title: 'How would you like us to edit the text?' }
    "
  ></ng-container>
  <div class="atn-platform-writing-helper-pop-up__editor">
    <atn-ds-text-area
      class="atn-platform-writing-helper-pop-up__editor-input"
      [(value)]="customEnhancementTypeSg"
    />
    <i
      class="atn-icon atn-run atn-blue"
      (click)="
        writingHelperFeature.actions.selectEnhancementType
          .from('WritingHelper.PopUp.CustomEnhancement.Run.Clicked')
          .dispatch({ enhancementType: customEnhancementTypeSg() })
      "
    ></i>
  </div>
} @else {
  <ng-container
    *ngTemplateOutlet="header; context: { title: 'Make my selection...' }"
  ></ng-container>
  <div class="atn-platform-writing-helper-pop-up__options">
    @for (enhancementType of enhancementTypeOptions; track $index) {
      <div
        class="atn-platform-writing-helper-pop-up__option"
        (click)="
          writingHelperFeature.actions.selectEnhancementType
            .from('WritingHelper.PopUp.EnhancementTypeOption.Clicked')
            .dispatch({ enhancementType })
        "
      >
        {{ enhancementType }}
      </div>
    }
  </div>
}
